export const profilesData = [
  {
    profileName: "Blood Counts",
    icon: "blood-test.png",
  },
  {
    profileName: "Liver Profile",
    icon: "LiverProfile-icon.png",
  },
  {
    profileName: "Lipid Profile",
    icon: "LipidProfile-icon.png",
  },
  {
    profileName: "Kidney Profile",
    icon: "KidneyProfile-icon.png",
  },
  {
    profileName: "Thyroid Profile",
    icon: "ThyroidProfile-icon.png",
  },
  {
    profileName: "Electrolyte Profile",
    icon: "electrolyte-profile.png",
  },
  {
    profileName: "Diabetes Monitoring",
    icon: "diabetes-profile.png",
  },
  {
    profileName: "Anemia Studies",
    icon: "anemia-studies.png",
  },
  {
    profileName: "Urinalysis",
    icon: "urinalysis.png",
  },
  {
    profileName: "Vitamin Profile",
    icon: "VitaminProfile-icon.png",
  },
];

const extraProfiles = [
  {
    profileName: "Cardiac Profile",
    icon: "CardiacProfile-icon.png",
  },
  {
    profileName: "Arthritis Screening",
    icon: "arthritis-screening.png",
  },
  {
    profileName: "Cancer Profile",
    icon: "cancer-profile.png",
  },
];

export const profileParameterData = {
  "Blood Counts": {
    normal: {
      test_name: "Blood Counts",
      parameters: [
        {
          parameter_name: "Haemoglobin",
          parameter_value: "15",
          min_value: "13",
          max_value: "17",
          is_abnormal: false,
        },
        {
          parameter_name: "RBC count",
          parameter_value: "5.2",
          min_value: "4.7",
          max_value: "6.1",
          is_abnormal: false,
        },
        {
          parameter_name: "Total Leukocyte Count",
          parameter_value: "7000",
          min_value: "4000",
          max_value: "11000",
          is_abnormal: false,
        },
        {
          parameter_name: "Platelet Count",
          parameter_value: "250000",
          min_value: "150000",
          max_value: "450000",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Blood Counts",
      parameters: [
        {
          parameter_name: "Haemoglobin",
          parameter_value: "10",
          min_value: "13",
          max_value: "17",
          is_abnormal: true,
        },
        {
          parameter_name: "RBC count",
          parameter_value: "5.2",
          min_value: "4.7",
          max_value: "6.1",
          is_abnormal: false,
        },
        {
          parameter_name: "Total Leukocyte Count",
          parameter_value: "3000",
          min_value: "4000",
          max_value: "11000",
          is_abnormal: true,
        },
        {
          parameter_name: "Platelet Count",
          parameter_value: "120000",
          min_value: "150000",
          max_value: "450000",
          is_abnormal: true,
        },
      ],
    },
  },
  "Lipid Profile": {
    normal: {
      test_name: "Lipid Profile",
      parameters: [
        {
          parameter_name: "Total Cholesterol",
          parameter_value: "150",
          min_value: "125",
          max_value: "200",
          is_abnormal: false,
        },
        {
          parameter_name: "LDL Cholesterol",
          parameter_value: "120",
          min_value: "100",
          max_value: "129",
          is_abnormal: false,
        },
        {
          parameter_name: "HDL Cholesterol",
          parameter_value: "50",
          min_value: "40",
          max_value: "60",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Lipid Profile",
      parameters: [
        {
          parameter_name: "Total Cholesterol",
          parameter_value: "250",
          min_value: "125",
          max_value: "200",
          is_abnormal: true,
        },
        {
          parameter_name: "LDL Cholesterol",
          parameter_value: "140",
          min_value: "100",
          max_value: "129",
          is_abnormal: true,
        },
        {
          parameter_name: "HDL Cholesterol",
          parameter_value: "50",
          min_value: "40",
          max_value: "60",
          is_abnormal: false,
        },
      ],
    },
  },
  "Liver Profile": {
    normal: {
      test_name: "Liver Profile",
      parameters: [
        {
          parameter_name: "Albumin",
          parameter_value: "4",
          min_value: "3.5",
          max_value: "5",
          is_abnormal: false,
        },
        {
          parameter_name: "Protein (Total)",
          parameter_value: "7",
          min_value: "6.4",
          max_value: "8.3",
          is_abnormal: false,
        },
        {
          parameter_name: "Total Bilirubin",
          parameter_value: "0.8",
          min_value: "0.3",
          max_value: "1.2",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Liver Profile",
      parameters: [
        {
          parameter_name: "Albumin",
          parameter_value: "4",
          min_value: "3.5",
          max_value: "5",
          is_abnormal: false,
        },
        {
          parameter_name: "Protein (Total)",
          parameter_value: "10",
          min_value: "6.4",
          max_value: "8.3",
          is_abnormal: true,
        },
        {
          parameter_name: "Total Bilirubin",
          parameter_value: "1.8",
          min_value: "0.3",
          max_value: "1.2",
          is_abnormal: true,
        },
      ],
    },
  },
  "Kidney Profile": {
    normal: {
      test_name: "Kidney Profile",
      parameters: [
        {
          parameter_name: "Serum Creatinine",
          parameter_value: "1.1",
          min_value: "0.6",
          max_value: "1.3",
          is_abnormal: false,
        },
        {
          parameter_name: "Blood Urea Nitrogen (BUN)",
          parameter_value: "10",
          min_value: "6",
          max_value: "20",
          is_abnormal: false,
        },
        {
          parameter_name: "Uric Acid",
          parameter_value: "6",
          min_value: "3",
          max_value: "7",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Kidney Profile",
      parameters: [
        {
          parameter_name: "Serum Creatinine",
          parameter_value: "0.5",
          min_value: "0.6",
          max_value: "1.3",
          is_abnormal: true,
        },
        {
          parameter_name: "Blood Urea Nitrogen (BUN)",
          parameter_value: "23",
          min_value: "6",
          max_value: "20",
          is_abnormal: true,
        },
        {
          parameter_name: "Uric Acid",
          parameter_value: "6",
          min_value: "3",
          max_value: "7",
          is_abnormal: false,
        },
      ],
    },
  },
  "Thyroid Profile": {
    normal: {
      test_name: "Thyroid Profile",
      parameters: [
        {
          parameter_name: "TSH",
          parameter_value: "2.1",
          min_value: "0.4",
          max_value: "4",
          is_abnormal: false,
        },
        {
          parameter_name: "T3 (Triiodothyronine)",
          parameter_value: "100",
          min_value: "80",
          max_value: "200",
          is_abnormal: false,
        },
        {
          parameter_name: "T4 (Thyroxine)",
          parameter_value: "8",
          min_value: "4.5",
          max_value: "11.2",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Thyroid Profile",
      parameters: [
        {
          parameter_name: "TSH",
          parameter_value: "5.1",
          min_value: "0.4",
          max_value: "4",
          is_abnormal: true,
        },
        {
          parameter_name: "T3 (Triiodothyronine)",
          parameter_value: "70",
          min_value: "80",
          max_value: "200",
          is_abnormal: true,
        },
        {
          parameter_name: "T4 (Thyroxine)",
          parameter_value: "8",
          min_value: "4.5",
          max_value: "11.2",
          is_abnormal: false,
        },
      ],
    },
  },
  "Diabetes Monitoring": {
    normal: {
      test_name: "Diabetes Monitoring",
      parameters: [
        {
          parameter_name: "Blood Sugar (Fasting)",
          parameter_value: "85",
          min_value: "70",
          max_value: "100",
          is_abnormal: false,
        },
        {
          parameter_name: "HbA1c (Glycosylated Haemoglobin)",
          parameter_value: "6",
          min_value: "5.7",
          max_value: "6.4",
          is_abnormal: false,
        },
        {
          parameter_name: "Insulin (Fasting)",
          parameter_value: "15",
          min_value: "3",
          max_value: "25",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Diabetes Monitoring",
      parameters: [
        {
          parameter_name: "Blood Sugar (Fasting)",
          parameter_value: "110",
          min_value: "70",
          max_value: "100",
          is_abnormal: true,
        },
        {
          parameter_name: "HbA1c (Glycosylated Haemoglobin)",
          parameter_value: "7",
          min_value: "5.7",
          max_value: "6.4",
          is_abnormal: true,
        },
        {
          parameter_name: "Insulin (Fasting)",
          parameter_value: "15",
          min_value: "3",
          max_value: "25",
          is_abnormal: false,
        },
      ],
    },
  },
  "Electrolyte Profile": {
    normal: {
      test_name: "Electrolyte Profile",
      parameters: [
        {
          parameter_name: "Sodium",
          parameter_value: "140",
          min_value: "135",
          max_value: "145",
          is_abnormal: false,
        },
        {
          parameter_name: "Potassium",
          parameter_value: "4",
          min_value: "3.5",
          max_value: "5",
          is_abnormal: false,
        },
        {
          parameter_name: "Calcium",
          parameter_value: "9.2",
          min_value: "8.6",
          max_value: "10.2",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Electrolyte Profile",
      parameters: [
        {
          parameter_name: "Sodium",
          parameter_value: "120",
          min_value: "135",
          max_value: "145",
          is_abnormal: true,
        },
        {
          parameter_name: "Potassium",
          parameter_value: "7",
          min_value: "3.5",
          max_value: "5",
          is_abnormal: true,
        },
        {
          parameter_name: "Calcium",
          parameter_value: "9.2",
          min_value: "8.6",
          max_value: "10.2",
          is_abnormal: false,
        },
      ],
    },
  },
  "Anemia Studies": {
    normal: {
      test_name: "Anemia Studies",
      parameters: [
        {
          parameter_name: "Iron",
          parameter_value: "130",
          min_value: "60",
          max_value: "170",
          is_abnormal: false,
        },
        {
          parameter_name: "Ferritin",
          parameter_value: "200",
          min_value: "30",
          max_value: "400",
          is_abnormal: false,
        },
        {
          parameter_name: "TIBC",
          parameter_value: "320",
          min_value: "250",
          max_value: "450",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Anemia Studies",
      parameters: [
        {
          parameter_name: "Iron",
          parameter_value: "50",
          min_value: "60",
          max_value: "170",
          is_abnormal: true,
        },
        {
          parameter_name: "Ferritin",
          parameter_value: "200",
          min_value: "30",
          max_value: "400",
          is_abnormal: false,
        },
        {
          parameter_name: "TIBC",
          parameter_value: "200",
          min_value: "250",
          max_value: "450",
          is_abnormal: true,
        },
      ],
    },
  },
  Urinalysis: {
    normal: {
      test_name: "Urinalysis",
      parameters: [
        {
          parameter_name: "pH",
          parameter_value: "6",
          min_value: "4.5",
          max_value: "8",
          is_abnormal: false,
        },
        {
          parameter_name: "Protein",
          parameter_value: "nil",
          min_value: "",
          max_value: "",
          is_abnormal: false,
        },
        {
          parameter_name: "Urine in Glucose",
          parameter_value: "nil",
          min_value: "",
          max_value: "",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Urinalysis",
      parameters: [
        {
          parameter_name: "pH",
          parameter_value: "6",
          min_value: "4.5",
          max_value: "8",
          is_abnormal: false,
        },
        {
          parameter_name: "Protein",
          parameter_value: "present",
          min_value: "",
          max_value: "",
          is_abnormal: true,
        },
        {
          parameter_name: "Urine in Glucose",
          parameter_value: "present",
          min_value: "",
          max_value: "",
          is_abnormal: true,
        },
      ],
    },
  },
  "Vitamin Profile": {
    normal: {
      test_name: "Vitamin Profile",
      parameters: [
        {
          parameter_name: "Vitamin D (25-Hydroxy)",
          parameter_value: "30",
          min_value: "20",
          max_value: "50",
          is_abnormal: false,
        },
        {
          parameter_name: "Vitamin B12",
          parameter_value: "600",
          min_value: "200",
          max_value: "900",
          is_abnormal: false,
        },
      ],
    },
    abnormal: {
      test_name: "Vitamin Profile",
      parameters: [
        {
          parameter_name: "Vitamin D (25-Hydroxy)",
          parameter_value: "10",
          min_value: "20",
          max_value: "50",
          is_abnormal: true,
        },
        {
          parameter_name: "Vitamin B12",
          parameter_value: "600",
          min_value: "200",
          max_value: "900",
          is_abnormal: false,
        },
      ],
    },
  },
};

export const sampleResponse = {
  data: [
    {
      cohort_data: {
        abnormal_tests: [
          "Anemia Studies",
          "Blood Counts",
          "Diabetes Monitoring",
        ],
        all_cohorts: {
          "High Risk + High/Moderate Abnormal": [],
          "High Risk + Slightly Abnormal / Medium Risk + High Abnormal": [
            "Iron - Significantly Low",
            "Haemoglobin - Significantly High",
          ],
          "Low Risk + Slightly Abnormal": [],
          "Medium Risk + Moderate/Slightly Abnormal / Low Risk + High Abnormal":
            ["RBC count - Slightly Low"],
          Normal: ["TIBC - Normal"],
          Uncohorted: [],
        },
        all_parameters_observed_values: [
          {
            parameters: [
              {
                is_abnormal: true,
                max_value: "205.1",
                min_value: "59.2",
                parameter_name: "Iron",
                parameter_value: "10",
                tag: {
                  comment: "Significantly Low",
                  tag: 3,
                },
              },
              {
                is_abnormal: false,
                max_value: "428",
                min_value: "228",
                parameter_name: "TIBC",
                parameter_value: "411",
                tag: {
                  comment: "Normal",
                  tag: 0,
                },
              },
            ],
            test_name: "Anemia Studies",
          },
          {
            parameters: [
              {
                is_abnormal: true,
                max_value: "17",
                min_value: "12",
                parameter_name: "Haemoglobin",
                parameter_value: "50",
                tag: {
                  comment: "Significantly High",
                  tag: 3,
                },
              },
              {
                is_abnormal: true,
                max_value: "5.9",
                min_value: "4.3",
                parameter_name: "RBC count",
                parameter_value: "4",
                tag: {
                  comment: "Slightly Low",
                  tag: 1,
                },
              },
            ],
            test_name: "Blood Counts",
          },
        ],
        bill_date: "2024-03-17 14:03:00",
        main_cohort: "long gap",
        report_id: "276465",
        sub_cohort: 2,
        tests_taken: [
          "Anemia Studies",
          "Blood Counts",
          "BMI & BP",
          "Diabetes Monitoring",
          "Electrolyte Profile",
          "Kidney Profile",
          "Lipid Profile",
          "Liver Profile",
          "Thyroid Profile",
          "Vitamin Profile",
        ],
      },
      cohort_db_id: 1,
    },
  ],
  success: true,
};
